import { IState } from "@/redux/store.types";
import { getValueState } from "@/redux/utils";

import { $PaintCollectionModuleName } from "./paintCollection.types";

const getPaintCollection = (state: IState) => {
    return getValueState(state, $PaintCollectionModuleName)?.collection;
};

export { getPaintCollection };
